import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import {
  Modal, Message, Breadcrumb, Icon, List, Table
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import CvssDisplay from '../Security/CvssDisplay';

class SecurityDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMSD: props.isOpenMSD,
      cveData: props.cveData,
      cveCode: props.selectedCode,
      isOnline: navigator.onLine,
    };
    this.handleNavigateToNvd = this.handleNavigateToNvd.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    //window.addEventListener('online', this.updateOnlineStatus);
    //window.addEventListener('offline', this.updateOnlineStatus);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMSD, cveData, selectedCode } = this.props;
    if (prevProps.isOpenMSD !== isOpenMSD) {
      this.setState({
        isOpenMSD,
        cveData,
        cveCode: selectedCode,
        isOnline: navigator.onLine,
      });
    }
  }

  componentWillUnmount() {
    //window.removeEventListener('online', this.updateOnlineStatus);
    //window.removeEventListener('offline', this.updateOnlineStatus);
  }

  handleNavigateToNvd() {
    const { cveCode, isOnline } = this.state;
    if (isOnline) {
      const match = cveCode.match(/CVE-\d{4}-\d{4,7}/);
      const extractedCveCode = match ? match[0] : '';

      if (extractedCveCode) {
        window.open(`https://nvd.nist.gov/vuln/detail/${extractedCveCode}`, '_blank');
      } else {
        console.error('Invalid CVE code');
      }
    }
  }

  /*
  updateOnlineStatus() {
    this.setState({ isOnline: navigator.onLine });
  }
  */

  closeModal(e) {
    const { closeModal } = this.props;
    e.preventDefault();
    this.setState({
      isOpenMSD: false,
    });
    closeModal();
  }

  renderReference = (source, desc, url, tags) => {
    const { t } = this.props;
    const refDatas = Object.assign(source.map((k, i) => {
      return {
        key: k || null,
        url: url ? url[i] : null,
        tag: tags ? tags[i] : null,
      };
    }));

    return (
      <Table
        className="reference"
        celled
        padded
        fixed
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2}>{t('modal.title.source')}</Table.HeaderCell>
            <Table.HeaderCell width={3}>{t('modal.title.tag')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            refDatas.map((item) => {
              return (
                <Table.Row key={[uuidv4() || null].join('')}>
                  <Table.Cell
                    title={[item.key || null].join('')}
                    verticalAlign="middle"
                  >
                    {item.key || null}
                  </Table.Cell>
                  <Table.Cell
                    title={[item.tag || null].join('')}
                    verticalAlign="top"
                  >
                    {item.tag ? item.tag.map((nest, idx) => {
                      if (idx === 0) {
                        return (
                          <div key={nest}>
                            {nest}
                            <br />
                          </div>
                        );
                      }
                      return (
                        <div key={nest} style={{ marginTop: '1px' }}>
                          {nest}
                          <br />
                        </div>
                      );
                    }) : null}
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  };

  renderVulnPkg = (array) => {
    let nextCIndex;
    let nextWIndex;
    let wIndex;
    let isStartTab = false;
    const cIndexTotal = [];
    const wIndexTotal = [];

    if (!array) {
      return;
    }
    array.findIndex((o, index) => {
      if (o.indexOf('Configuration') > -1) {
        cIndexTotal.push(index);
      }
      if (o.indexOf('With') > -1) {
        wIndexTotal.push(index);
      }
      return null;
    });

    const result = array.map(
      (vuln, idx) => {
        if (wIndexTotal.length !== 0 && wIndexTotal.indexOf(idx) > -1) {
          isStartTab = true;
        }

        if (cIndexTotal.length !== 0 && cIndexTotal.indexOf(idx) > -1) {
          isStartTab = false;
        }

        if (vuln.indexOf('Configuration') > -1) {
          const currentIndex = cIndexTotal.findIndex((o) => {
            return o === idx;
          });
          nextCIndex = cIndexTotal[currentIndex + 1];

          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 0',
                  border: 0,
                  fontWeight: 'bold',
                  background: '#f7f7f7',
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        if (vuln.indexOf('With') > -1) {
          wIndex = idx;
          const currentIndex = wIndexTotal.findIndex((o) => {
            return o === idx;
          });
          nextWIndex = wIndexTotal[currentIndex + 1];
          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 10px',
                  border: 0,
                  fontWeight: 'bold'
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        if (wIndex && nextWIndex && nextCIndex && wIndex < idx < nextWIndex && idx < nextCIndex && isStartTab) {
          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 20px',
                  border: 0,
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        return (
          <tr key={uuidv4()}>
            <td
              style={{
                fontSize: '13px',
                wordBreak: 'break-all',
                padding: '5px 0 5px 10px',
                border: 0,
              }}
            >
              {vuln}
            </td>
          </tr>
        );
      }
    );
    return result;
  };

  render() {
    const { t } = this.props;
    const {
      isOpenMSD,
      cveCode,
      cveData,
      isOnline,
    } = this.state;

    const breadCrumb_class = isOnline ? 'online' : '';

    return (
      <Modal open={isOpenMSD} onClose={this.closeModal}>
        <div className="more_info_popup" style={{ borderRadius: '20px' }}>
          <div className="popup_header ">
            <h4 className="popup_name">
              <Icon name="info circle" />
              <Breadcrumb>
                <Breadcrumb.Section
                  onClick={isOnline ? this.handleNavigateToNvd : null}
                  className={breadCrumb_class}
                >
                  {cveCode}
                </Breadcrumb.Section>
              </Breadcrumb>
            </h4>
            <a className="close_button" style={{ cursor: 'pointer' }} onClick={this.closeModal} onKeyUp={this.closeModal}>
              <img src={closeBtn} alt="" />
            </a>
          </div>
          {cveData.more_info ? (
            <Scrollbars
              renderTrackHorizontal={() => {
                return <div />;
              }}
              renderThumbHorizontal={() => {
                return <div />;
              }}
            >
              <div className="popup_contents">
                <div className="popup_content_wrap">
                  <Message header={t('list.title.description')} content={cveData.description} />
                </div>
                <CvssDisplay
                  securityInfo={cveData.more_info}
                  translate={t}
                />
                {cveData.evidence_info
                  && cveData.evidence_info.evidence_type !== 'no_evidence' && (
                  <div className="popup_content_wrap">
                    <p className="label">
                      <Icon name="shield" size={18} />
                      {cveData.evidence_info.evidence_status
                          && t(
                            `list.title.${cveData.evidence_info.evidence_status}`
                          )}
                    </p>
                    <div className="ui segment">
                      <h4 className="ui header">
                        {t('list.title.description')}
                      </h4>
                      <div className="ui list list_wrap">
                        {cveData.evidence_info.evidence_description}
                      </div>
                    </div>
                  </div>
                )}
                {
                  cveData.more_info.rejected ? (
                    <div className="popup_content_wrap">
                      <p className="label">{t('modal.cve.rejected')}</p>
                      <div className="value" style={{ color: '#912d2b' }}>{cveData.more_info.rejected}</div>
                    </div>
                  ) : null
                }
                <div className="popup_content_wrap">
                  <p className="label">{t('modal.cve.common_weakness_enumeration')}</p>
                  <div className="value">{cveData.more_info.type}</div>
                </div>
                <div className="popup_content_wrap">
                  <p className="label">{t('modal.cve.published_date')}</p>
                  <div className="value">{cveData.more_info.pdate}</div>
                </div>
                <div className="popup_content_wrap">
                  <p className="label">{t('modal.cve.last_modified_date')}</p>
                  <div className="value">{cveData.more_info.mdate}</div>
                </div>
                {
                  cveData.more_info.refsource.length !== 0 ? (
                    <div className="popup_content_wrap">
                      <p className="label">{t('modal.cve.references')}</p>
                      {this.renderReference(cveData.more_info.refsource, cveData.more_info.refdescription, cveData.more_info.web_site, cveData.more_info.reftags)}
                    </div>
                  ) : null
                }
                {cveData.more_info.patch_url.length !== 0 ? (
                  <div className="popup_content_wrap">
                    <p className="label">{t('modal.cve.pathc_url')}</p>
                    <List>
                      {cveData.more_info.patch_url.map((url) => {
                        return (
                          <List.Item className="patch_url" key={uuidv4()}>
                            <List.Content>
                              <a href={url} target="_blank" rel="noopener noreferrer">
                                {url}
                              </a>
                            </List.Content>
                          </List.Item>
                        );
                      })}
                    </List>
                  </div>
                ) : null}
                <div className="line" />
                <div className="popup_content_wrap">
                  <p className="label">{t('modal.cve.vulnerable_packages')}</p>
                </div>
                {cveData.more_info.vuln_sw.length !== 0 ? (
                  <div className="popup_content_wrap">
                    <table
                      className="table"
                      style={{ marginBottom: '30px', tableLayout: 'fixed' }}
                    >
                      <tbody>
                        {this.renderVulnPkg(cveData.more_info.vuln_sw)}
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </div>
            </Scrollbars>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(SecurityDetailModal))));
